import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AlertController,
  IonInput,
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { Store } from "@ngrx/store";
import {
  auditTime,
  catchError,
  distinctUntilChanged,
  first,
  Subscription,
} from "rxjs";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { DataStorageService } from "src/app/services/data-storage/data-storage.service";
import { Loader } from "@googlemaps/js-api-loader";
import mapStyleJson from "../../../assets/mapStyle/mapStyle.json";
import mapStyleJsonDark from "../../../assets/mapStyle/mapStyleDark.json";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import { v4 as uuid } from "uuid";
import { DeliveryAreasInfoModalComponent } from "src/app/delivery-areas/delivery-areas-info-modal/delivery-areas-info-modal.component";
import * as AuthActions from "../../auth/store/auth.actions";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { Geolocation } from "@capacitor/geolocation";
import { AnimationOptions } from "ngx-lottie";
import { AnimationStyles } from "@ionic/core/dist/types/utils/animation/animation-interface";
import { Capacitor } from "@capacitor/core";

declare let window: any;
@Component({
  selector: "app-new-address-modal",
  templateUrl: "./new-address-modal.component.html",
  styleUrls: ["./new-address-modal.component.scss"],
})
export class NewAddressModalComponent implements OnInit, OnDestroy {
  @Input() disableSelectAddress: any;
  @ViewChild("autoCompleteInput") input: ElementRef;
  public gpsMode: boolean = false;
  public newAddress: any;
  public deliveryAreas: any;
  public renderCardDeliveryAreas: any;
  public selectedLanguage: string;
  public groupApp: any;
  public libraryLoaded: boolean = false;
  public loading: boolean = false;
  public loadingForInputs: boolean = false;
  public showDownInfoMarkerAnimation;
  public showUpInfoMarkerAnimation;
  public infoForGooglePostalCodeRegion: any;
  public inputPulseAnimation = false;
  public gpsLocation: any;
  public ionLoading: any;
  public stores: any;
  public map: any;
  public mobileMarkerVisible = false;
  public mobilePlatform: boolean;
  public validation = {
    street: true,
    street_number: true,
    post_code: false,
  };
  mapOptions = {};
  search;
  autocomplete;
  marker;
  geocoder;
  autocompleteService;
  hideDeliveryCard: boolean = false;
  public infoForMoveTheMarker: any;
  public infoForStopMovingTheMarker: any;
  public getAddressFromCoordinatesLoading: boolean = false;
  public gpsMarker: any;
  public addressInputsChanged: boolean = false;
  public addressInputsFocus: boolean = false;
  public saveAddressLoading = false;
  public hideMap: boolean = false;
  public loader: any;
  public mo_token: any;
  public mobileMarkerInfo: any;
  public addressFromGps: any;
  public searchButtonDisabled: boolean = true;
  public geoLocationAnimation: boolean = false;
  public geoAnimationInstance: any;
  public selectedTheme: string;
  public currentStore: any;

  private gpsEditAddressAlert: any;
  private subs: Subscription[] = [];
  private currentUser: any;
  private enterKey: any;
  private DeliveryAreaInfoModal: any;
  private unsubscribeBackEvent: Subscription;
  private geoErrMessage: any;
  private gpsErrorAlert: any;
  private postCodeChangeGps: boolean = false;
  private storeMarkers: any[] = [];
  private storeMarkerToast: any;

  options: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/location-animation.json",
  };

  styles: AnimationStyles = {};

  // private store_info: any;
  // private minOrder: any;
  // private deliveryCost: any;

  constructor(
    private modalController: ModalController,
    private store: Store<fromApp.AppState>,
    private changeDetector: ChangeDetectorRef,
    private toastController: ToastController,
    private translateService: TranslateService,
    private dataStorageService: DataStorageService,
    private alertController: AlertController,
    private platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private loadingController: LoadingController
  ) {}

  animationCreated(ev) {
    this.geoAnimationInstance = ev;
    this.geoAnimationInstance.setSpeed(1.5);
  }

  capacitorIsNativePlatform() {
    return Capacitor.isNativePlatform();
  }

  ngOnInit() {
    if (this.capacitorIsNativePlatform()) {
      this.mobilePlatform = true;
      this.mobileMarkerInfo = {
        header: null,
        message1: null,
        message2: null,
      };

      this.gpsPromptAlert();
    } else {
      this.mobilePlatform = false;
    }
    setTimeout(() => {
      this.inputPulseAnimation = true;
      this.changeDetector.detectChanges();
    }, 800);

    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          if (this.gpsEditAddressAlert) {
            this.gpsEditAddressAlert.dismiss();
            this.gpsEditAddressAlert = null;
          } else {
            this.modalController.dismiss();
          }
        }
      }
    );
    this.subs.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(100))
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            !_.isEqual(this.groupApp, state.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
            if (
              this.groupApp &&
              this.selectedLanguage &&
              this.stores &&
              this.selectedTheme
            ) {
              this.createMapsScript();
            }
          }
          if (
            state &&
            state.selectedLangugage &&
            this.groupApp &&
            !_.isEqual(this.selectedLanguage, state.selectedLangugage)
          ) {
            this.selectedLanguage = _.cloneDeep(state.selectedLangugage);
            if (
              this.groupApp &&
              this.selectedLanguage &&
              this.stores &&
              this.selectedTheme
            ) {
              this.createMapsScript();
            }
          }
          if (
            state &&
            state.selectedTheme &&
            !_.isEqual(this.selectedTheme, state.selectedTheme)
          ) {
            this.selectedTheme = _.cloneDeep(state.selectedTheme);
            if (this.selectedTheme && this.map) {
              if (this.selectedTheme === "dark") {
                this.map.set("styles", mapStyleJsonDark);
              } else {
                this.map.set("styles", mapStyleJson);
              }
            }
          }
        })
    );

    this.subs.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .pipe(auditTime(100))
        .subscribe((storeInfo) => {
          if (storeInfo && !_.isEqual(storeInfo, this.currentStore)) {
            this.currentStore = _.cloneDeep(storeInfo);
          }
        })
    );

    this.subs.push(
      this.store
        .select("stores")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(100))
        .subscribe((state) => {
          if (state && state.stores && !_.isEqual(state.stores, this.stores)) {
            this.stores = _.cloneDeep(state.stores);
            if (
              this.groupApp &&
              this.selectedLanguage &&
              this.stores &&
              this.selectedTheme
            ) {
              this.createMapsScript();
            }
          }
        })
    );
    this.subs.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(100))
        .subscribe((state) => {
          if (state && state.user && !_.isEqual(state.user, this.currentUser)) {
            this.currentUser = _.cloneDeep(state.user);
          }
          if (
            state &&
            state.mo_token &&
            !_.isEqual(state.mo_token, this.mo_token)
          ) {
            this.mo_token = _.cloneDeep(state.mo_token);
          }
        })
    );
    if (!this.capacitorIsNativePlatform()) {
      setTimeout(() => {
        if (this.input && this.input.nativeElement) {
          this.input.nativeElement.focus();
        }
      }, 1000);
    }
  }

  createMapsScript() {
    if (!document.getElementById("googleMapsLoader")) {
      this.loader = new Loader({
        id: "googleMapsLoader",
        apiKey: this.groupApp.googleMapsKey,
        language: this.selectedLanguage,
        libraries: ["geometry", "drawing", "places"],
      });
      this.loader.load().then(() => {
        //  console.log("library loaded");
        this.libraryLoaded = true;
        this.changeDetector.detectChanges();
        this.initializationSetAddress();
      });
    } else {
      this.libraryLoaded = true;
      this.changeDetector.detectChanges();
      this.initializationSetAddress();
      // this.loader = new Loader({
      //   id: "googleMapsLoader",
      //   apiKey: this.groupApp.googleMapsKey,
      //   libraries: ["geometry", "drawing", "places"],
      // });
    }
  }

  async gpsPromptAlert() {
    const alert = await this.alertController.create({
      header: this.translateService.instant("new-address-modal.location"),
      message: this.translateService.instant(
        "new-address-modal.do-you-want-to-find-you-location-from-gps"
      ),
      buttons: [
        {
          text: this.translateService.instant("no"),
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            // if (navigator.cookieEnabled) {
            //   let obj = {
            //     asked: true,
            //     granted: false,
            //   };
            //   localStorage.setItem("gps_permissions", JSON.stringify(obj));
            // }
          },
        },
        {
          text: this.translateService.instant("yes"),
          handler: () => {
            this.gpsMode = true;
            if (this.map) {
              this.map.setOptions({
                draggable: true,
                scaleControl: true,
                scrollwheel: true,
                mapTypeControl: false,
                zoomControlOptions: this.mobilePlatform ? false : true,
                disableDoubleClickZoom: false,

                zoomControl: false,
              });
            }

            // if (navigator.cookieEnabled) {
            //   let obj = {
            //     asked: true,
            //     granted: true,
            //   };
            //   localStorage.setItem("gps_permissions", JSON.stringify(obj));
            // }
            this.checkLocationFromGps();
          },
        },
      ],
    });

    await alert.present();
  }

  goToNextStep() {
    if (
      this.addressFromGps &&
      (this.addressFromGps.postal_code ||
        this.addressFromGps.street ||
        this.addressFromGps.street_number)
    ) {
      //this.getAddressFromCoordinatesLoading = true;
      if (this.gpsLocation.lat && this.gpsLocation.lng) {
        this.showEditAddressAlert(
          this.addressFromGps.street,
          this.addressFromGps.street_number,
          this.addressFromGps.postal_code,
          this.addressFromGps.city,
          this.addressFromGps.state,
          this.addressFromGps.region
        );
      }
      // this.checkAutoCompleteAddress(
      //   this.addressFromGps.street,
      //   this.addressFromGps.street_number,
      //   this.addressFromGps.postal_code,
      //   this.gpsLocation.lat,
      //   this.gpsLocation.lng,
      //   null,
      //   null,
      //   false,
      //   true
      // );
    }
  }

  async showEditAddressAlert(
    street,
    street_number,
    postal_code,
    city,
    state,
    region
  ) {
    const initialPostalCode = postal_code;

    this.gpsEditAddressAlert = await this.alertController.create({
      header: this.translateService.instant("new-address-modal.address"),
      inputs: [
        {
          name: "street",
          type: "text",
          value: street ? street : "",
          placeholder: this.translateService.instant(
            "new-address-modal.street"
          ),
        },
        {
          name: "street_number",
          type: "text",
          value: street_number ? street_number : "",
          placeholder: this.translateService.instant(
            "new-address-modal.street-number"
          ),
        },

        {
          name: "postal_code",
          type: "text",
          value: postal_code ? postal_code : "",
          placeholder: this.translateService.instant(
            "new-address-modal.post-code"
          ),
        },
      ],
      buttons: [
        {
          text: this.translateService.instant("cancel"),
          role: "cancel",
          cssClass: "secondary",
          handler: () => {
            console.log("Confirm Cancel");
          },
        },
        {
          text: this.translateService.instant("new-address-modal.save-address"),
          handler: (data) => {
            if (
              data &&
              (!data.postal_code || !data.street || !data.street_number)
            ) {
              const formatted_address =
                data.street +
                " " +
                data.street_number +
                ", " +
                (city ? city + " " : "") +
                data.postal_code;

              let newAddressGps = {
                googleLat: this.gpsLocation.lat,
                googleLng: this.gpsLocation.lng,
                userLat: this.gpsLocation.lat,
                userLng: this.gpsLocation.lng,
                formatted_address: formatted_address,
                address_components: {
                  street: _.cloneDeep(data.street),
                  street_number: _.cloneDeep(data.street_number),
                  postal_code: _.cloneDeep(data.postal_code),
                  region: _.cloneDeep(region) || null,
                  state: _.cloneDeep(state) || null,
                  city: _.cloneDeep(city) || null,
                },
              };
              this.onSaveAddressFromGps(_.cloneDeep(newAddressGps));
              return false;
            } else {
              const formatted_address =
                data.street +
                " " +
                data.street_number +
                ", " +
                (city ? city + " " : "") +
                data.postal_code;
              let newAddressGps = {
                googleLat: this.gpsLocation.lat,
                googleLng: this.gpsLocation.lng,
                userLat: this.gpsLocation.lat,
                userLng: this.gpsLocation.lng,
                formatted_address: formatted_address,
                address_components: {
                  street: _.cloneDeep(data.street),
                  street_number: _.cloneDeep(data.street_number),
                  postal_code: _.cloneDeep(data.postal_code),
                  region: _.cloneDeep(region) || null,
                  state: _.cloneDeep(state) || null,
                  city: _.cloneDeep(city) || null,
                },
              };
              this.getAddressFromCoordinatesLoading = true;
              this.dataStorageService
                .getAddressFromCoordinates(
                  newAddressGps.userLat,
                  newAddressGps.userLng,
                  this.selectedLanguage,
                  this.groupApp.googleMapsCountryCode,
                  this.groupApp.group,
                  initialPostalCode !== data.postal_code
                    ? data.postal_code
                    : null
                )
                .subscribe({
                  next: async (res: any) => {
                    this.postCodeChangeGps = false;
                    if (!res || !res.success) {
                      this.getAddressFromCoordinatesLoading = false;

                      let errorMessage;

                      if (
                        res &&
                        res.comment_id &&
                        res.comment_id ===
                          "please_check_your_post_code_and_try_again"
                      ) {
                        errorMessage =
                          "errorMessages.please_check_your_post_code_and_try_again";
                      } else if (res && res.comment_id) {
                        errorMessage = res.comment_id;
                      } else if (res.comments) {
                        errorMessage = res.comments;
                      } else {
                        errorMessage = "errorMessages.general_error";
                      }

                      const alert = await this.alertController.create({
                        header: this.translateService.instant("alert"),
                        message: this.translateService.instant(errorMessage),
                        backdropDismiss: false,
                        buttons: ["OK"],
                      });
                      await alert.present();
                    } else {
                      this.getAddressFromCoordinatesLoading = false;
                      this.deliveryAreas = res.deliveryAreas;
                      this.calculateRenderedDeliveryAreas();

                      console.log("this delivery areas", this.deliveryAreas);

                      this.onSaveAddressFromGps(_.cloneDeep(newAddressGps));
                    }
                  },
                  error: async (error) => {
                    this.getAddressFromCoordinatesLoading = false;
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("alert"),
                      message: this.translateService.instant(
                        "errorMessages.problem_reaching_server"
                      ),

                      buttons: ["OK"],
                    });
                    await alert.present();
                    return error;
                  },
                });
            }

            console.log("Confirm Ok");
          },
        },
      ],
    });

    await this.gpsEditAddressAlert.present();
  }

  checkLocationFromGps() {
    this.presentGeolocationLoading();
    // this.getAddressFromCoordinatesDebounce({
    //   lat: 40.6099517,
    //   lng: 22.9564049,
    // });
    this.hideDeliveryCard = true;
    Geolocation.getCurrentPosition({
      timeout: 12000,
      enableHighAccuracy: true,
    })
      .then((resp) => {
        console.log("inside then with this data", resp);
        if (resp.coords && resp.coords.latitude && resp.coords.longitude) {
          let position = new google.maps.LatLng({
            lat: resp.coords.latitude,
            lng: resp.coords.longitude,
          });
          if (this.capacitorIsNativePlatform()) {
            this.getAddressFromCoordinatesDebounce({
              lat: resp.coords.latitude,
              lng: resp.coords.longitude,
            });
            this.map.setCenter(position);

            setTimeout(() => {
              this.map.setZoom(19);
            }, 200);
          } else {
            //gps on browser
          }
        } else {
          // if (this.ionLoading) {
          //   this.ionLoading.dismiss();
          //   this.ionLoading = null;
          // }
          if (this.geoLocationAnimation) {
            this.geoLocationAnimation = false;
          }
          //cant getting coords
        }
      })
      .catch(async (err) => {
        setTimeout(() => {
          // if (this.ionLoading) {
          //   this.ionLoading.dismiss();
          //   this.ionLoading = null;
          // }
          if (this.geoLocationAnimation) {
            this.geoLocationAnimation = false;
          }
        }, 100);

        console.log("errr", err);
        if (
          err &&
          err.message &&
          (err.message === "Timeout expired" ||
            err.message === "User denied Geolocation")
        ) {
          this.geoErrMessage = this.translateService.instant(
            "delivery-areas.please-enable-gps-in-order-to-get-accurate-results"
          );
          if (this.gpsErrorAlert) {
            this.gpsErrorAlert.dismiss();
            this.gpsErrorAlert = null;
          }
          this.gpsErrorAlert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.geoErrMessage,
            buttons: [
              {
                text: this.translateService.instant("cancel"),
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  this.resetTheProccess();
                },
              },
              {
                text: this.translateService.instant(
                  "new-address-modal.locate-again"
                ),

                handler: () => {
                  this.checkLocationFromGps();
                },
              },
            ],
          });

          await this.gpsErrorAlert.present();
          this.gpsErrorAlert.onDidDismiss().then(() => {
            this.gpsErrorAlert = null;
          });
        } else if (err && err.message && err.message === "Illegal Access") {
          this.geoErrMessage = this.translateService.instant(
            "delivery-areas.you-can-enable-gps-from-app-setting-in-order-to-find-your-location"
          );
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.geoErrMessage,
            buttons: ["OK"],
          });

          await alert.present();
          alert.onDidDismiss().then(() => {
            this.geoErrMessage = null;
            this.resetTheProccess();
          });
        } else {
          this.geoErrMessage = this.translateService.instant(
            "delivery-areas.we-cant-find-you-location-please-enable-gps-and-grant-permissions"
          );
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.geoErrMessage,
            buttons: [
              {
                text: this.translateService.instant("cancel"),
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  this.resetTheProccess();
                },
              },
              {
                text: this.translateService.instant(
                  "new-address-modal.locate-again"
                ),

                handler: () => {
                  this.checkLocationFromGps();
                },
              },
            ],
          });

          await alert.present();
          alert.onDidDismiss().then(() => {
            this.geoErrMessage = null;
            //this.resetTheProccess();
          });
        }
      });
  }

  async presentGeolocationLoading() {
    if (this.gpsMarker) {
      this.gpsMarker.setVisible(false);
      this.gpsMarker = null;
    }
    this.geoLocationAnimation = true;

    console.log("Loading dismissed!");
  }

  ondismiss() {
    this.modalController.dismiss();
  }

  onClickSearch() {
    if (
      this.input &&
      this.input.nativeElement &&
      this.input.nativeElement.value
    ) {
      this.checkAutoCompleteAddress(
        this.input.nativeElement.value,
        null,
        null,
        null,
        null,
        null,
        null,
        false,
        false
      );
    } else {
      this.presentErrorToast(
        this.translateService.instant(
          "new-address-modal.please-write-you-address-in-the-input"
        ),
        "danger"
      );
    }
  }

  initializationSetAddress() {
    console.log("initializations map");
    this.map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        zoom: parseInt(this.groupApp.groupMapZoom),
        gestureHandling: "greedy",
        center: {
          lat: parseFloat(this.groupApp.groupMapCenterLat),
          lng: parseFloat(this.groupApp.groupMapCenterLng),
        },

        zoomControl: this.mobilePlatform ? false : true,
        scaleControl: false,
        scrollwheel: true,
        disableDefaultUI: true,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles:
          this.selectedTheme && this.selectedTheme === "dark"
            ? mapStyleJsonDark
            : mapStyleJson,
      }
    );
    this.store
      .select(selectors.getStoreInfo)
      .pipe(first())
      .subscribe((storeInfo) => {
        if (storeInfo && !storeInfo.disableDeliveryAreas) {
          this.deliveryAreasInitialization(this.map);
        }
      })
      .unsubscribe();

    google.maps.event.addListenerOnce(this.map, "idle", () => {
      this.autoCompleteInitializations();
    });
    var icon = {
      url: "assets/ionicons/home.png", // url
      scaledSize: new google.maps.Size(60, 60),
    };
    if (!this.capacitorIsNativePlatform()) {
      this.marker = new google.maps.Marker({
        animation: google.maps.Animation.DROP,
        icon: icon,

        map: this.map,

        draggable: true,
      });
    } else {
      this.mobileMarkerVisible = false;
    }
    // console.log("drugstart");
    if (!this.capacitorIsNativePlatform()) {
      google.maps.event.addListener(this.marker, "dragstart", () => {
        if (this.infoForMoveTheMarker) {
          this.infoForMoveTheMarker.close();
          this.infoForMoveTheMarker = null;
        }
        if (this.infoForGooglePostalCodeRegion) {
          this.infoForGooglePostalCodeRegion.close();
          this.infoForGooglePostalCodeRegion = null;
        }
        this.closeStoreInfoWindows();
      });
    } else {
      this.map.addListener("dragstart", () => {
        this.mobileMarkerInfo = {
          header: null,
          message1: null,
          message2: null,
        };
        // this.showDownInfoMarkerAnimation = false;
        // this.changeDetector.detectChanges();
        // setTimeout(() => {
        //   this.showUpInfoMarkerAnimation = true;
        // }, 50);
      });
    }

    if (!this.capacitorIsNativePlatform()) {
      google.maps.event.addListener(this.marker, "dragend", () => {
        let newPlace = this.marker.getPosition();
        let marker = { lat: newPlace.lat(), lng: newPlace.lng() };

        console.log("moving the marker request again", newPlace);

        if (this.infoForMoveTheMarker) {
          this.infoForMoveTheMarker.close();
          this.infoForMoveTheMarker = null;
        }
        this.infoForStopMovingTheMarker = new google.maps.InfoWindow({
          content: this.hintWindowContent(
            "<div style='line-height: 1.35; overflow: hidden; white-space: nowrap; color:black;'>" +
            "<ion-item color='white' lines='none' style='--min-height: 30px; padding: 0; margin: 0; color:black;'> <ion-spinner color='primary' slot='start' name='dots'></ion-spinner><ion-label style='color:black;padding: 0; margin: 0'>" +
            this.translateService.instant("new-address-modal.loading") +
            "</ion-label></ion-item> </div>"),
          headerDisabled: true,
          pixelOffset: this.hintWindowPixelOffset(),
        });
        this.infoForStopMovingTheMarker.open(this.map, this.marker);
        //Send the marker object to the request
        this.marker.setDraggable(false);
        this.checkAutoCompleteAddress(
          this.newAddress.address_components.street,
          this.newAddress.address_components.street_number,
          this.newAddress.address_components.postal_code,
          marker.lat,
          marker.lng,
          this.newAddress.address_components.googleLat,
          this.newAddress.address_components.googleLng,
          true,
          false
        );
      });
    } else {
      //TO_DO FOR MOBILE
      // this.mobileMarkerInfo = this.translateService.instant(
      //   "new-address-modal.loading"
      // );

      this.map.addListener("dragend", () => {
        // console.log("dragend");
        if (!this.gpsMode && this.newAddress) {
          this.dragEndEventMobileCheckAddressDebounce();
        } else {
          // this.showUpInfoMarkerAnimation = false;
          // setTimeout(() => {
          //   this.showDownInfoMarkerAnimation = true;
          // }, 100);
          // if (this.mobilePlatform) {
          //   this.map.setOptions({ draggable: false });
          // }
          // this.getAddressFromCoordinatesDebounce({
          //   lat: this.map.getCenter().lat(),
          //   lng: this.map.getCenter().lng(),
          // });
        }
      });
    }

    this.changeDetector.detectChanges();

    this.storeMarkersInitialization(this.map);
  }

  autoCompleteInitializations() {
    var bounds = this.map.getBounds();
    const options = {
      types: ["address"],
      bounds: new google.maps.LatLngBounds(
        bounds.getSouthWest(),
        bounds.getNorthEast()
      ),
      componentRestrictions: {
        country: this.groupApp.googleMapsCountryCode,
      },
    };
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("autocomplete") as HTMLInputElement,
      options
    );

    this.autocompleteService = new google.maps.places.AutocompleteService();
    const geocoder = new google.maps.Geocoder();
    this.autocomplete.bindTo("bounds", this.map);
    if (this.input && this.input.nativeElement) {
      this.enterKey = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          this.onClickSearch();
        }
        // do something
      };
      this.input.nativeElement.addEventListener("keyup", this.enterKey);
    }

    this.autocomplete.addListener("place_changed", () => {
      const place: google.maps.places.PlaceResult =
        this.autocomplete.getPlace();
      //  console.log("place changed event", place);
      this.checkAutoCompleteAddress(
        place && place.formatted_address ? place.formatted_address : place.name,
        null,
        null,
        null,
        null,
        null,
        null,
        false,
        false
      );
    });
  }

  private getAddressFromCoordinatesDebounce = _.debounce((gpsLocation) => {
    this.gpsLocation = _.cloneDeep(gpsLocation);
    this.getAddressFromCoordinates(gpsLocation);
  }, 1000);

  private dragEndEventMobileCheckAddressDebounce = _.debounce(() => {
    //this.showUpInfoMarkerAnimation = false;
    // setTimeout(() => {
    //   this.showDownInfoMarkerAnimation = true;
    // }, 50);
    if (this.mobilePlatform) {
      this.map.setOptions({ draggable: false });
    }
    this.checkAutoCompleteAddressDebounced(
      this.newAddress.address_components.street,
      this.newAddress.address_components.street_number,
      this.newAddress.address_components.postal_code,
      this.map.getCenter().lat(),
      this.map.getCenter().lng(),
      this.newAddress.address_components.googleLat,
      this.newAddress.address_components.googleLng,
      true
    );
  }, 1000);

  private checkAutoCompleteAddressDebounced = _.debounce(
    (
      street,
      street_number,
      postal_code,
      userLat,
      userLng,
      googleLat,
      googleLng,
      forMarker
    ) => {
      this.checkAutoCompleteAddress(
        street,
        street_number,
        postal_code,
        userLat,
        userLng,
        googleLat,
        googleLng,
        forMarker,
        false
      );
    },
    100
  );

  async checkAutoCompleteAddress(
    street,
    street_number,
    postal_code,
    userLat,
    userLng,
    googleLat,
    googleLng,
    forMarker,
    fixAddressAlert
  ) {
    if (
      street &&
      !street_number &&
      !postal_code &&
      !userLat &&
      !userLng &&
      !googleLat &&
      !googleLng &&
      !forMarker
    ) {
      this.loading = true;
      this.changeDetector.detectChanges();

      this.dataStorageService
        .checkAutoCompleteAddres(
          street,
          null,
          null,
          null,
          null,
          null,
          null,
          this.selectedLanguage,
          this.groupApp.googleMapsCountryCode,
          this.groupApp.group
        )

        .subscribe({
          next: async (res: any) => {
            if (!res || !res.success) {
              if (this.mobilePlatform) {
                if (!this.gpsMode) {
                  this.map.setOptions({ draggable: true });
                } else {
                  this.getAddressFromCoordinatesLoading = false;
                }
              }

              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message:
                  res && res.comment_id
                    ? this.translateService.instant(res.comment_id)
                    : this.translateService.instant(
                        "errorMessages.general_error"
                      ),
                backdropDismiss: false,
                buttons: ["OK"],
              });
              await alert.present();
            } else {
              if (this.mobilePlatform) {
                this.map.setOptions({
                  draggable: true,
                  scrollwheel: true,
                  zoomControlOptions: true,
                  disableDoubleClickZoom: false,

                  zoomControl: false,
                });
                this.gpsMode = false;
                this.getAddressFromCoordinatesLoading = false;

                this.addressFromGps = null;
                google.maps.event.clearListeners(this.map, "dragstart");
                google.maps.event.clearListeners(this.map, "dragend");
                this.map.addListener("dragstart", () => {
                  this.mobileMarkerInfo = {
                    header: null,
                    message1: null,
                    message2: null,
                  };
                  // this.showDownInfoMarkerAnimation = false;
                  // setTimeout(() => {
                  //   this.showUpInfoMarkerAnimation = true;
                  // }, 50);
                  this.changeDetector.detectChanges();
                });
                this.map.addListener("dragend", () => {
                  // console.log("dragend");
                  this.dragEndEventMobileCheckAddressDebounce();
                });
                this.map.setOptions({ draggable: true });
              }

              this.addressInputsChanged = false;
              this.addressInputsFocus = false;
              if (res.currentAddress) {
                this.newAddress = res.currentAddress;
                if (!this.newAddress.userLat && !this.newAddress.userLng) {
                  const alert = await this.alertController.create({
                    header: this.translateService.instant("alert"),

                    message: this.translateService.instant(
                      "new-address-modal.please-fill-all-the-address-fields"
                    ),
                    buttons: ["OK"],
                  });

                  await alert.present();
                }
              }
              if (res.deliveryAreas) {
                this.deliveryAreas = res.deliveryAreas;
                this.calculateRenderedDeliveryAreas();

                console.log("this delivery areas", this.deliveryAreas);
              }
              console.log("response new address", this.newAddress);
              this.checkAddressFields();
              if (this.newAddress.userLat && this.newAddress.userLng) {
                this.hideMap = false;

                this.setMarker(
                  {
                    lat: this.newAddress.userLat,
                    lng: this.newAddress.userLng,
                  },
                  true
                );

                this.changeDetector.detectChanges();
              } else {
                if (!this.capacitorIsNativePlatform()) {
                  this.marker.setVisible(false);
                  if (this.infoForMoveTheMarker) {
                    this.infoForMoveTheMarker.close();
                    this.infoForMoveTheMarker = null;
                  }
                } else {
                  //TO_DO FOR MOBILE
                  if (fixAddressAlert) {
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("notification"),
                      message: this.translateService.instant(
                        "new-address-modal.fix-address-fields-to-correct-your-address"
                      ),

                      backdropDismiss: false,
                      buttons: ["OK"],
                    });
                    await alert.present();
                  }
                  this.mobileMarkerVisible = false;
                }
                this.hideMap = true;
              }
              this.loading = false;

              this.changeDetector.detectChanges();
            }
            console.log("autocomplete api response", res);
          },
          error: async (err) => {
            if (this.mobilePlatform) {
              if (!this.gpsMode) {
                this.map.setOptions({ draggable: true });
              } else {
                this.getAddressFromCoordinatesLoading = false;
              }
            }

            const alert = await this.alertController.create({
              header: this.translateService.instant("alert"),
              message: this.translateService.instant(
                "errorMessages.problem_reaching_server"
              ),

              buttons: ["OK"],
            });
            await alert.present();
            return err;

            console.log("error updating the information");
          },
        });
    } else {
      if (!street) {
        const alert = await this.alertController.create({
          header: this.translateService.instant("alert"),

          message: this.translateService.instant(
            "new-address-modal.please-fill-street"
          ),
          buttons: ["OK"],
        });

        await alert.present();

        if (this.mobilePlatform) {
          this.map.setOptions({
            draggable: true,
            scrollwheel: true,
            zoomControlOptions: true,
            disableDoubleClickZoom: false,

            zoomControl: false,
          });
          if (this.gpsMarker) {
            this.gpsMarker.setVisible(false);
          }
          this.gpsMode = false;
          this.getAddressFromCoordinatesLoading = false;
          this.mobileMarkerVisible = true;
          this.addressFromGps = null;
          google.maps.event.clearListeners(this.map, "dragstart");
          google.maps.event.clearListeners(this.map, "dragend");
          this.map.addListener("dragstart", () => {
            this.mobileMarkerInfo = {
              header: null,
              message1: null,
              message2: null,
            };
            // this.showDownInfoMarkerAnimation = false;
            // setTimeout(() => {
            //   this.showUpInfoMarkerAnimation = true;
            // }, 50);
            this.changeDetector.detectChanges();
          });
          this.map.addListener("dragend", () => {
            // console.log("dragend");
            this.dragEndEventMobileCheckAddressDebounce();
          });
          this.map.setOptions({ draggable: true });
          if (fixAddressAlert) {
            const alert = await this.alertController.create({
              header: this.translateService.instant("notification"),
              message: this.translateService.instant(
                "new-address-modal.fix-address-fields-to-correct-your-address"
              ),

              backdropDismiss: false,
              buttons: ["OK"],
            });
            await alert.present();
          }
        }

        if (!this.mobilePlatform) {
          if (forMarker) {
            if (this.infoForStopMovingTheMarker) {
              this.infoForStopMovingTheMarker.close();
            }

            this.marker.setDraggable(true);
          } else {
            if (this.newAddress.unverified) {
            }
          }
        }
        this.addressInputsChanged = false;
        this.addressInputsFocus = false;

        this.checkAddressFields();
      } else {
        this.loadingForInputs = true;
        this.changeDetector.detectChanges();
        this.dataStorageService
          .checkAutoCompleteAddres(
            street,
            street_number,
            postal_code,
            userLat,
            userLng,
            googleLat,
            googleLng,
            this.selectedLanguage,
            this.groupApp.googleMapsCountryCode,
            this.groupApp.group
          )
          .subscribe({
            next: async (res: any) => {
              if (!res || !res.success) {
                if (this.mobilePlatform) {
                  this.map.setOptions({
                    draggable: true,
                    scrollwheel: true,
                    zoomControlOptions: true,
                    disableDoubleClickZoom: false,

                    zoomControl: false,
                  });
                  if (this.gpsMarker) {
                    this.gpsMarker.setVisible(false);
                  }
                  this.gpsMode = false;
                  this.getAddressFromCoordinatesLoading = false;
                  this.mobileMarkerVisible = true;
                  this.addressFromGps = null;
                  google.maps.event.clearListeners(this.map, "dragstart");
                  google.maps.event.clearListeners(this.map, "dragend");
                  this.map.addListener("dragstart", () => {
                    this.mobileMarkerInfo = {
                      header: null,
                      message1: null,
                      message2: null,
                    };
                    // this.showDownInfoMarkerAnimation = false;
                    // setTimeout(() => {
                    //   this.showUpInfoMarkerAnimation = true;
                    // }, 50);
                    this.changeDetector.detectChanges();
                  });
                  this.map.addListener("dragend", () => {
                    // console.log("dragend");
                    this.dragEndEventMobileCheckAddressDebounce();
                  });
                  this.map.setOptions({ draggable: true });
                  if (fixAddressAlert) {
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("notification"),
                      message: this.translateService.instant(
                        "new-address-modal.fix-address-fields-to-correct-your-address"
                      ),

                      backdropDismiss: false,
                      buttons: ["OK"],
                    });
                    await alert.present();
                  }
                }

                if (!this.mobilePlatform) {
                  if (forMarker) {
                    if (this.infoForStopMovingTheMarker) {
                      this.infoForStopMovingTheMarker.close();
                    }

                    this.marker.setDraggable(true);
                  } else {
                    if (this.newAddress.unverified) {
                    }
                  }
                }
                this.addressInputsChanged = false;
                this.addressInputsFocus = false;

                this.checkAddressFields();

                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message:
                    res && res.comment_id
                      ? this.translateService.instant(res.comment_id)
                      : this.translateService.instant(
                          "errorMessages.general_error"
                        ),
                  backdropDismiss: false,
                  buttons: ["OK"],
                });
                await alert.present();
              } else {
                if (this.mobilePlatform) {
                  this.map.setOptions({
                    draggable: true,
                    scrollwheel: true,
                    zoomControlOptions: true,
                    disableDoubleClickZoom: false,

                    zoomControl: false,
                  });
                  if (this.gpsMarker) {
                    this.gpsMarker.setVisible(false);
                  }
                  this.gpsMode = false;
                  this.getAddressFromCoordinatesLoading = false;
                  this.mobileMarkerVisible = true;
                  this.addressFromGps = null;
                  google.maps.event.clearListeners(this.map, "dragstart");
                  google.maps.event.clearListeners(this.map, "dragend");
                  this.map.addListener("dragstart", () => {
                    this.mobileMarkerInfo = {
                      header: null,
                      message1: null,
                      message2: null,
                    };
                    // this.showDownInfoMarkerAnimation = false;
                    // setTimeout(() => {
                    //   this.showUpInfoMarkerAnimation = true;
                    // }, 50);
                    this.changeDetector.detectChanges();
                  });
                  this.map.addListener("dragend", () => {
                    // console.log("dragend");
                    this.dragEndEventMobileCheckAddressDebounce();
                  });
                  this.map.setOptions({ draggable: true });
                  if (fixAddressAlert) {
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("notification"),
                      message: this.translateService.instant(
                        "new-address-modal.fix-address-fields-to-correct-your-address"
                      ),

                      backdropDismiss: false,
                      buttons: ["OK"],
                    });
                    await alert.present();
                  }
                }

                if (res.currentAddress) {
                  this.newAddress = res.currentAddress;
                  if (!this.newAddress.userLat && !this.newAddress.userLng) {
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("alert"),

                      message: this.translateService.instant(
                        "new-address-modal.please-fill-all-the-address-fields"
                      ),
                      buttons: ["OK"],
                    });

                    await alert.present();
                  }
                }
                if (res.deliveryAreas) {
                  this.deliveryAreas = res.deliveryAreas;
                  this.calculateRenderedDeliveryAreas();
                  // console.log("this delivery areas", this.deliveryAreas);
                }
                if (!this.mobilePlatform) {
                  if (forMarker) {
                    if (this.infoForStopMovingTheMarker) {
                      this.infoForStopMovingTheMarker.close();
                    }

                    this.marker.setDraggable(true);
                  } else {
                    if (this.newAddress.unverified) {
                    }
                  }
                }
                this.addressInputsChanged = false;
                this.addressInputsFocus = false;

                this.checkAddressFields();
                if (this.newAddress.userLat && this.newAddress.userLng) {
                  this.hideMap = false;
                  if (forMarker) {
                    this.setMarker(
                      {
                        lat: this.newAddress.userLat,
                        lng: this.newAddress.userLng,
                      },
                      false
                    );
                  } else {
                    if (!this.capacitorIsNativePlatform()) {
                      this.setMarker(
                        {
                          lat: this.newAddress.userLat,
                          lng: this.newAddress.userLng,
                        },
                        true
                      );
                    } else {
                      this.setMarker(
                        {
                          lat: this.newAddress.userLat,
                          lng: this.newAddress.userLng,
                        },
                        true
                      );
                    }
                  }

                  this.changeDetector.detectChanges();
                } else {
                  this.hideMap = true;

                  if (!this.capacitorIsNativePlatform()) {
                    this.marker.setVisible(false);

                    if (this.infoForMoveTheMarker) {
                      this.infoForMoveTheMarker.close();
                      this.infoForMoveTheMarker = null;
                    }
                  } else {
                    this.mobileMarkerVisible = false;
                    this.mobileMarkerInfo = {
                      header: null,
                      message1: null,
                      message2: null,
                    };
                    //TO_DO FOR MOBILE
                  }
                }

                this.loadingForInputs = false;
                this.changeDetector.detectChanges();
              }
              console.log("autocomplete api response", res);
            },
            error: async (err) => {
              if (this.mobilePlatform) {
                this.map.setOptions({ draggable: true });
                this.getAddressFromCoordinatesLoading = false;
              }
              if (this.infoForStopMovingTheMarker) {
                this.infoForStopMovingTheMarker.close();
                this.infoForStopMovingTheMarker = null;
              }

              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message: this.translateService.instant(
                  "errorMessages.problem_reaching_server"
                ),

                buttons: ["OK"],
              });
              await alert.present();
              return err;

              console.log("error updating the information");
            },
          });
      }
    }
  }

  calculateRenderedDeliveryAreas() {
    if (this.deliveryAreas && this.deliveryAreas.length) {
      this.renderCardDeliveryAreas = _.cloneDeep(this.deliveryAreas);
    } else {
      this.renderCardDeliveryAreas = [];
    }
    if (
      this.deliveryAreas &&
      this.deliveryAreas.length &&
      this.stores &&
      this.stores.length == 1
    ) {
      let areaWithShedule = _.find(this.deliveryAreas, (area) => {
        if (area.showSchedule) {
          return true;
        }
      });
      if (!areaWithShedule) {
        this.renderCardDeliveryAreas = _.cloneDeep([
          _.head(
            _.orderBy(
              this.deliveryAreas,
              ["minOrder", "deliveryCost"],
              ["asc", "asc"]
            )
          ),
        ]);
      }
    } else if (
      this.deliveryAreas &&
      this.deliveryAreas.length &&
      this.stores &&
      this.stores.length > 1
    ) {
      let areaWithShedule = _.find(this.deliveryAreas, (area) => {
        if (area.showSchedule) {
          return true;
        }
      });
      if (!areaWithShedule) {
        let tempAreas = [];
        _.each(this.stores, (store) => {
          tempAreas.push(
            _.cloneDeep(
              _.head(
                _.orderBy(
                  this.deliveryAreas.filter(
                    (area) => store.store_id === area.store_id
                  ),
                  ["minOrder", "deliveryCost"],
                  ["asc", "asc"]
                )
              )
            )
          );
        });

        if (tempAreas && tempAreas.length > 0) {
          tempAreas = _.cloneDeep(
            tempAreas.filter((element) => {
              return element !== undefined;
            })
          );
          this.renderCardDeliveryAreas = tempAreas;
          //  console.log("tempsareas", this.renderCardDeliveryAreas);
        }
      }
    }
    this.hideDeliveryCard = false;
    // Precompute dynamic per-km (radius) delivery costs for template performance
    this.computeDynamicRadiusCosts(this.renderCardDeliveryAreas);
    //console.log("rendered delivery areas", this.renderCardDeliveryAreas);
  }

  // Calculate delivery cost for per-km areas based on current address/marker
  // Mirrors logic used in DeliveryAreasPage with minimal local copy.
  getAreaDeliveryCost(area: any): string {
    try {
      if (!area || !area.delivery_cost_per_kilometer_active) {
        return area && area.deliveryCost ? String(area.deliveryCost) : "0.00";
      }

      const store = _.find(this.stores, { store_id: area.store_id });
      if (!store || !store.mapCenterStoreLat || !store.mapCenterStoreLng) {
        return String(area.deliveryCost || "0.00");
      }

      // Determine origin point; prefer current address coords first, then marker, then GPS
      let originLatLng: any = null;
      if (
        this.newAddress &&
        this.newAddress.userLat &&
        this.newAddress.userLng
      ) {
        originLatLng = new google.maps.LatLng(
          this.newAddress.userLat,
          this.newAddress.userLng
        );
      } else if (this.marker && this.marker.getPosition) {
        originLatLng = this.marker.getPosition();
      } else if (
        this.gpsLocation &&
        this.gpsLocation.lat &&
        this.gpsLocation.lng
      ) {
        originLatLng = new google.maps.LatLng(
          this.gpsLocation.lat,
          this.gpsLocation.lng
        );
      }

      if (!originLatLng || !google || !google.maps || !google.maps.geometry) {
        return String(area.deliveryCost || "0.00");
      }

      const storeLatLng = new google.maps.LatLng(
        parseFloat(store.mapCenterStoreLat),
        parseFloat(store.mapCenterStoreLng)
      );

      // Distance in meters
      const meters = google.maps.geometry.spherical.computeDistanceBetween(
        originLatLng,
        storeLatLng
      );
      let distanceKm = parseFloat((meters / 1000).toFixed(2));

      if (area.distance_charge_type === "levels") {
        const stepRoundUp = (num, param) => {
          if (param <= 0) {
            throw new Error("Parameter must be a positive number");
          }
          return Math.ceil(num / param) * param;
        };

        const distanceMetersRounded = stepRoundUp(
          parseFloat(parseFloat((distanceKm * 1000).toString()).toFixed(2)),
          area.step_active && area.step_distance ? area.step_distance : 1000
        );
        distanceKm = parseFloat(
          parseFloat((distanceMetersRounded / 1000).toString()).toFixed(2)
        );
      }

      return this.calculateDeliveryCostByKmCasesStandalone(
        area.charge_after_distance,
        area.step_active,
        area.step_distance,
        area.fixed_charge,
        distanceKm,
        area
      );
    } catch (e) {
      return area && area.deliveryCost ? String(area.deliveryCost) : "0.00";
    }
  }

  private calculateDeliveryCostByKmCasesStandalone(
    charge_after_distance: any,
    step_active: any,
    step_distance: any,
    fixed_charge: any,
    distance_by_store_id: any,
    currentValidStore: any
  ): string {
    const getDeliveryCost = (multiplier, fixedCharge) => {
      let deliveryCost: any = currentValidStore.deliveryCost
        ? parseFloat(
            currentValidStore.deliveryCost.toString().replace(",", ".")
          )
        : 0;

      deliveryCost = (deliveryCost * multiplier + (fixedCharge || 0)).toFixed(
        2
      );

      if (deliveryCost && parseFloat(deliveryCost.toString())) {
        deliveryCost = parseFloat(
          parseFloat(deliveryCost.toString()).toFixed(1)
        ).toFixed(2);
      }

      return deliveryCost;
    };

    const calculateDistanceToCharge = () => {
      let distanceToCharge = distance_by_store_id * 1000;
      if (charge_after_distance) {
        distanceToCharge -= charge_after_distance;
        if (distanceToCharge < 0) {
          distanceToCharge = 0;
        }
      }
      return distanceToCharge || 0;
    };

    const distanceToCharge = calculateDistanceToCharge();

    if (step_active && step_distance) {
      const numberOfSteps = Math.floor(distanceToCharge / step_distance);
      if (numberOfSteps >= 0) {
        return getDeliveryCost(numberOfSteps, fixed_charge);
      } else {
        return "0.00";
      }
    } else {
      const distanceInKm = charge_after_distance
        ? parseFloat((distanceToCharge / 1000).toFixed(2))
        : distance_by_store_id;
      if (distanceInKm >= 0) {
        return getDeliveryCost(distanceInKm, fixed_charge);
      } else {
        return "0.00";
      }
    }
  }

  private computeDynamicRadiusCosts(areas: any[]) {
    if (!areas || !areas.length) return;
    _.each(areas, (area) => {
      if (
        area &&
        area.deliveryCost &&
        area.deliveryCost !== "0" &&
        area.delivery_cost_per_kilometer_active &&
        area.calculation_type === "radius"
      ) {
        area._dynamicDeliveryCost = this.getAreaDeliveryCost(area);
      } else {
        area._dynamicDeliveryCost = null;
      }
    });
  }

  getAddressFromCoordinates(gpsLocation) {
    if (gpsLocation && gpsLocation.lat && gpsLocation.lng) {
      this.getAddressFromCoordinatesLoading = true;

      this.dataStorageService
        .getAddressFromCoordinates(
          gpsLocation.lat,
          gpsLocation.lng,
          this.selectedLanguage,
          this.groupApp.googleMapsCountryCode,
          this.groupApp.group,
          null
        )
        .subscribe({
          next: async (res: any) => {
            // if (this.ionLoading) {
            //   this.ionLoading.dismiss();
            //   this.ionLoading = null;
            // }
            if (this.geoLocationAnimation) {
              this.geoLocationAnimation = false;
            }

            this.getAddressFromCoordinatesLoading = false;
            if (!res || !res.success) {
              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message:
                  res && res.comment_id
                    ? this.translateService.instant(res.comment_id)
                    : this.translateService.instant(
                        "errorMessages.general_error"
                      ),
                backdropDismiss: false,
                buttons: ["OK"],
              });
              await alert.present();
            } else {
              // console.log("getAddressFromCoordinates res", res);
              if (res.address) {
                this.addressFromGps = _.cloneDeep(res.address);
                var icon = {
                  url: "assets/flatIcons/gpsPin.svg", // url
                  scaledSize: new google.maps.Size(20, 20),
                };
                if (this.gpsMarker) {
                  this.gpsMarker.setVisible(false);
                  this.gpsMarker = null;
                }
                this.gpsMarker = new google.maps.Marker({
                  animation: google.maps.Animation.DROP,
                  icon: icon,

                  map: this.map,

                  draggable: false,
                });
                this.map.setZoom(19);
                this.gpsMarker.setPosition({
                  lat: gpsLocation.lat,
                  lng: gpsLocation.lng,
                });
                this.gpsMarker.setVisible(true);
                this.changeDetector.detectChanges();
              }
              if (res.deliveryAreas) {
                this.deliveryAreas = _.cloneDeep(res.deliveryAreas);
                this.calculateRenderedDeliveryAreas();
              }
              //TO_DO set map center and show marker for mobile
              //Show ion card with marker address from api
              //Show message to move the map in order to correct address
              //Show button with continue to go to next step
            }
          },
          error: async (err) => {
            // if (this.ionLoading) {
            //   this.ionLoading.dismiss();
            //   this.ionLoading = null;
            // }
            if (this.geoLocationAnimation) {
              this.geoLocationAnimation = false;
            }
            // if (this.mobilePlatform) {
            //   this.map.setOptions({ draggable: true });
            // }
            const alert = await this.alertController.create({
              header: this.translateService.instant("alert"),
              message: this.translateService.instant(
                "errorMessages.problem_reaching_server"
              ),

              buttons: ["OK"],
            });
            await alert.present();
            return err;
          },
        });
    } else {
      //TO_DO ERROR MESSAGE
      if (this.geoLocationAnimation) {
        this.geoLocationAnimation = false;
      }
      // if (this.ionLoading) {
      //   this.ionLoading.dismiss();
      //   this.ionLoading = null;
      // }
    }
  }

  showInfoBoxForMovingMarker() {
    if (this.infoForMoveTheMarker) {
      this.infoForMoveTheMarker = null;
    }
    this.infoForMoveTheMarker = new google.maps.InfoWindow({
      content: this.hintWindowContent(this.translateService.instant(
        "new-address-modal.move-the-marker-to-correct-your-address"
      )),
      headerDisabled: true,
      pixelOffset: this.hintWindowPixelOffset(),
    });

    this.infoForMoveTheMarker.open(this.map, this.marker);
  }

  deliveryAreasInitialization(map) {
    _.each(this.stores, (store, key, list) => {
      if (_.isEmpty(store.deliveryAreas) && store.boundaryCoordinates1) {
        console.log("Creating the group's delivery areas...");
        console.log("How many stores the group has: ", this.stores.length);
        //Polygon coordinates
        var boundary = store.boundaryCoordinates1;
        var boundaryData = [];
        var latlngMap = boundary.split(",");
        var lat = [];
        var lng = [];
        for (var i = 0; i < latlngMap.length; i++) {
          if (i % 2 === 0) {
            lat.push(latlngMap[i]);
          } else {
            lng.push(latlngMap[i]);
          }
        }
        for (i = 0; i < latlngMap.length / 2; i++) {
          boundaryData.push(new google.maps.LatLng(lat[i], lng[i]));
        }

        new google.maps.Polygon({
          paths: boundaryData,
          strokeColor: "#0000FF",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FFCC00", //YEllOW
          fillOpacity: 0.3,
          zIndex: 10,
          map: map,
        });
      } else {
        console.log("The store has the new deliveryAreas", store.deliveryAreas);
        _.each(store.deliveryAreas, (area, k, l) => {
          if (!area.active) {
            return;
          }

          var boundary = area.boundaries;
          var boundaryData = [];
          var latlngMap = boundary.split(",");
          var lat = [];
          var lng = [];
          for (var i = 0; i < latlngMap.length; i++) {
            if (i % 2 === 0) {
              lat.push(parseFloat(latlngMap[i]));
            } else {
              lng.push(parseFloat(latlngMap[i]));
            }
          }
          for (i = 0; i < latlngMap.length / 2; i++) {
            boundaryData.push(new google.maps.LatLng(lat[i], lng[i]));
          }

          new google.maps.Polygon({
            paths: boundaryData,
            strokeColor: area.strokeColor ? area.strokeColor : "#0000FF",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: area.fillColor ? area.fillColor : "#FFCC00",
            fillOpacity: area.fillOpacity ? parseFloat(area.fillOpacity) : 0.3,
            zIndex: 10,
            map: map,
          });
        });
      }
    });
  }

  storeMarkersInitialization(map) {
    this.clearStoreMarkers();
    if (
      !this.groupApp ||
      !this.groupApp.design_settings ||
      this.groupApp.design_settings.showStoreMarkersOnNewAddressMap !== true
    ) {
      return;
    }

    _.each(this.stores, (store) => {
      // Only stores that deliver get a pin: the order-now popup's rule, and then either
      // delivery to any address (disableDeliveryAreas, as the address check treats it)
      // or at least one active area, since the modal draws and the check match only those.
      if (
        !store ||
        store.disableOrderDelivery ||
        !store.deliveryAreas ||
        !store.deliveryAreas.length ||
        (!store.disableDeliveryAreas &&
          !_.some(store.deliveryAreas, (area) => area && area.active))
      ) {
        return;
      }
      const lat = parseFloat(store.mapCenterStoreLat);
      const lng = parseFloat(store.mapCenterStoreLng);
      if (!_.isFinite(lat) || !_.isFinite(lng) || (lat === 0 && lng === 0)) {
        return;
      }

      const storeName = this.getStoreMarkerName(store);
      const storeAddress = this.getStoreMarkerAddress(store);
      const storeMarker = {
        marker: new google.maps.Marker({
          icon: {
            url: "assets/ionicons/store-location.png",
            scaledSize: new google.maps.Size(40, 40),
          },
          position: { lat: lat, lng: lng },
          map: map,
          // The address is part of the accessible name, so screen readers get it from the
          // pin itself and not only from a short-lived toast.
          title: storeAddress ? storeName + ", " + storeAddress : storeName,
          draggable: false,
          // With a title, an unoptimized marker is reachable by keyboard and screen readers.
          optimized: false,
          // The home marker's default zIndex follows its screen position and goes
          // negative above the map centre, so only the minimum keeps every pin below it.
          zIndex: -google.maps.Marker.MAX_ZINDEX,
        }),
        // On native the map centre is the customer's address, so a pin shows a toast
        // instead of an info window that could only be read by moving the map.
        infoBox: this.capacitorIsNativePlatform()
          ? null
          : new google.maps.InfoWindow({
              headerContent: this.createStoreMarkerInfoLine(storeName, true),
              content: storeAddress
                ? this.createStoreMarkerInfoLine(storeAddress, false)
                : null,
            }),
      };
      storeMarker.marker.addListener("click", () => {
        this.onStoreMarkerClick(storeMarker, storeName, storeAddress);
      });
      this.storeMarkers.push(storeMarker);
    });
  }

  getStoreMarkerName(store) {
    return store.store_panel_name_langs &&
      store.store_panel_name_langs[this.selectedLanguage]
      ? store.store_panel_name_langs[this.selectedLanguage]
      : store.store_panel_name_langs && store.store_panel_name_langs.el
      ? store.store_panel_name_langs.el
      : store.store_name_panel
      ? store.store_name_panel
      : store.store_name
      ? store.store_name
      : "";
  }

  getStoreMarkerAddress(store) {
    if (this.groupApp.design_settings.hideStoreAddressOnStoreSelection) {
      return null;
    }
    const address =
      store.address_langs && store.address_langs[this.selectedLanguage]
        ? store.address_langs[this.selectedLanguage]
        : store.address_langs && store.address_langs.el
        ? store.address_langs.el
        : store.address;
    return address && address !== "null" && address !== "undefined"
      ? address
      : null;
  }

  // With headerDisabled, the InfoWindow keeps its 12px inner spacing only on the top
  // and left, so hint text touched the right and bottom edges; this evens it out.
  hintWindowContent(content) {
    return "<div style='padding: 0 12px 12px 0;'>" + content + "</div>";
  }

  // A hint window grows upwards from the home marker, so the bottom spacing above
  // would lift its text by 12px, under the address form on the smaller desktop modal
  // (600x500). Moving the tip 12px down keeps the text where it was without it.
  hintWindowPixelOffset() {
    return new google.maps.Size(0, 12);
  }

  createStoreMarkerInfoLine(text, bold) {
    const line = document.createElement("div");
    line.style.color = "black";
    if (bold) {
      line.style.fontWeight = "bold";
    } else {
      // The InfoWindow content area gets no inner spacing on the right or bottom
      // either, the same as the hint windows (see hintWindowContent).
      line.style.padding = "0 12px 12px 0";
    }
    line.textContent = text;
    return line;
  }

  onStoreMarkerClick(storeMarker, storeName, storeAddress) {
    this.closeStoreInfoWindows();
    if (!storeMarker.infoBox) {
      this.presentStoreMarkerToast(storeName, storeAddress);
      return;
    }
    // Once an address is set, the address form covers the top of the map, and a pin
    // near it would open its info window underneath. On web the address is the
    // draggable home marker, so centring the map on the pin does not move it.
    if (this.newAddress && !this.gpsMode) {
      this.map.setCenter(storeMarker.marker.getPosition());
    }
    storeMarker.infoBox.open(this.map, storeMarker.marker);
  }

  async presentStoreMarkerToast(storeName, storeAddress) {
    const toast = await this.toastController.create({
      header: storeName,
      message: storeAddress ? storeAddress : undefined,
      duration: 3000,
      position: "bottom",
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",
        },
      ],
    });
    // Replace the previous toast only now, so taps that overlap create() keep one
    // toast. If the modal closed meanwhile (the pins are cleared then), drop the
    // unpresented toast element instead of leaving it in the DOM.
    if (!this.storeMarkers.length) {
      toast.remove();
      return;
    }
    if (this.storeMarkerToast) {
      this.storeMarkerToast.dismiss();
    }
    this.storeMarkerToast = toast;
    toast.present();
  }

  closeStoreInfoWindows() {
    _.each(this.storeMarkers, (storeMarker) => {
      if (storeMarker.infoBox) {
        storeMarker.infoBox.close();
      }
    });
  }

  clearStoreMarkers() {
    _.each(this.storeMarkers, (storeMarker) => {
      google.maps.event.clearInstanceListeners(storeMarker.marker);
      if (storeMarker.infoBox) {
        storeMarker.infoBox.close();
      }
      storeMarker.marker.setMap(null);
    });
    this.storeMarkers = [];
  }

  focusOnInput() {
    this.addressInputsFocus = true;
    if (this.map) {
      this.map.set("zoomControl", false);
    }
    this.hideDeliveryCard = true;
  }

  BlurOnInput() {
    this.hideDeliveryCard = false;
    if (this.map) {
      this.map.set("zoomControl", true);
    }
  }

  onAutoCompleteFocus() {
    this.searchButtonDisabled = false;
    this.hideDeliveryCard = true;
    if (this.map) {
      this.map.set("zoomControl", false);
    }
  }

  onAutoCompleteBlur() {
    this.hideDeliveryCard = false;
    if (this.map) {
      this.map.set("zoomControl", true);
    }
  }

  checkAddressFields() {
    this.addressInputsChanged = true;

    this.validation.street_number = true;
    this.validation.post_code = true;
    this.validation.street = true;
    if (this.newAddress && this.newAddress.address_components) {
      if (!this.newAddress.address_components.postal_code) {
        this.validation.post_code = false;
      }
      if (!this.newAddress.address_components.street) {
        this.validation.street = false;
      }
      if (!this.newAddress.address_components.street_number) {
        this.validation.street_number = false;
      }
    }

    this.changeDetector.detectChanges();
  }

  resetTheProccess() {
    this.newAddress = null;

    if (this.mobilePlatform) {
      this.mobileMarkerInfo = {
        header: null,
        message1: null,
        message2: null,
      };

      if (this.gpsMode) {
        this.gpsLocation = null;
        this.addressFromGps = null;

        if (this.gpsMarker) {
          this.gpsMarker.setVisible(false);
        }
        this.gpsMode = false;
      }
    }

    if (this.input && this.input.nativeElement) {
      this.input.nativeElement.value = null;
    } else if (!this.input) {
      //TO_DO CHECK THIS HEERE
    }

    if (this.infoForMoveTheMarker) {
      this.infoForMoveTheMarker.close();
      this.infoForMoveTheMarker = null;
    }
    if (this.infoForGooglePostalCodeRegion) {
      this.infoForGooglePostalCodeRegion.close();
      this.infoForGooglePostalCodeRegion = null;
    }
    if (this.infoForStopMovingTheMarker) {
      this.infoForStopMovingTheMarker.close();
      this.infoForStopMovingTheMarker = null;
    }
    this.closeStoreInfoWindows();

    if (this.marker) {
      this.marker.setVisible(false);
    }

    if (this.map) {
      this.map.setZoom(parseInt(this.groupApp.groupMapZoom));
      this.map.setCenter({
        lat: parseFloat(this.groupApp.groupMapCenterLat),
        lng: parseFloat(this.groupApp.groupMapCenterLng),
      });
    }
    if (this.capacitorIsNativePlatform()) {
      google.maps.event.clearListeners(this.map, "dragstart");
      google.maps.event.clearListeners(this.map, "dragend");
    } else {
      // gps for browser
    }
    this.deliveryAreas = null;
    this.renderCardDeliveryAreas = null;
    this.hideMap = false;
    this.mobileMarkerVisible = false;
    this.changeDetectorDebounce();
  }

  changeDetectorDebounce = _.debounce(() => {
    this.changeDetector.detectChanges();
  }, 500);

  setMarker(location, setCenter) {
    if (setCenter) {
      this.closeStoreInfoWindows();
      this.map.setCenter(location);
      this.map.setZoom(19);
      this.mobileMarkerInfo = {
        header: null,
        message1: null,
        message2: null,
      };
      if (this.infoForMoveTheMarker) {
        this.infoForMoveTheMarker.close();
        this.infoForMoveTheMarker = null;
      }
      if (this.infoForGooglePostalCodeRegion) {
        this.infoForGooglePostalCodeRegion.close();
        this.infoForGooglePostalCodeRegion = null;
      }
      if (this.infoForStopMovingTheMarker) {
        this.infoForStopMovingTheMarker.close();
        this.infoForStopMovingTheMarker = null;
      }
      if (this.newAddress && this.newAddress.unverified) {
        if (!this.capacitorIsNativePlatform()) {
          this.infoForMoveTheMarker = new google.maps.InfoWindow({
            content: this.hintWindowContent(
              "<div style='font-weight: bold;' color='danger'>" +
              "<ion-text color='danger'>" +
              this.translateService.instant(
                "new-address-modal.your-address-is-unverified"
              ) +
              "</ion-text>" +
              "</div>" +
              "<div>" +
              "<ion-text style='font-weight:bold;' color='black'>" +
              this.translateService.instant(
                "new-address-modal.move-the-marker"
              ) +
              "</ion-text>" +
              "</div>" +
              "<div >" +
              "<ion-text style='font-weight:bold;'  color='black'>" +
              this.translateService.instant(
                "new-address-modal.to-correct-your-address"
              ) +
              "</ion-text>" +
              "</div>"),
            headerDisabled: true,
            pixelOffset: this.hintWindowPixelOffset(),
          });

          this.infoForMoveTheMarker.open(this.map, this.marker);
        } else {
          this.mobileMarkerInfo.header = this.translateService.instant(
            "new-address-modal.your-address-is-unverified"
          );
          this.mobileMarkerInfo.message1 =
            this.translateService.instant("new-address-modal.move-the-map") +
            " " +
            this.translateService.instant(
              "new-address-modal.to-correct-your-address"
            );
        }
      } else if (
        this.newAddress &&
        !this.newAddress.unverified &&
        this.newAddress.address_components &&
        this.newAddress.address_components.street &&
        this.newAddress.address_components.street_number &&
        this.newAddress.address_components.postal_code
      ) {
        if (!this.capacitorIsNativePlatform()) {
          this.infoForMoveTheMarker = new google.maps.InfoWindow({
            content: this.hintWindowContent(
              "<div style='font-weight:bold; color:black;' >" +
              this.translateService.instant(
                "new-address-modal.move-the-marker"
              ) +
              "</div>" +
              "<div style='font-weight:bold; color:black;'>" +
              this.translateService.instant(
                "new-address-modal.to-correct-your-address"
              ) +
              "</div>"),
            headerDisabled: true,
            pixelOffset: this.hintWindowPixelOffset(),
          });
          this.infoForMoveTheMarker.open(this.map, this.marker);
        } else {
          this.mobileMarkerInfo.header =
            this.translateService.instant("new-address-modal.move-the-map") +
            " " +
            this.translateService.instant(
              "new-address-modal.to-correct-your-address"
            );
        }
      }
    } else {
      if (
        this.newAddress &&
        this.newAddress.address_components &&
        this.newAddress.address_components.user_point_postal_code
      ) {
        if (!this.capacitorIsNativePlatform()) {
          if (this.infoForGooglePostalCodeRegion) {
            this.infoForGooglePostalCodeRegion.close();
            this.infoForGooglePostalCodeRegion = null;
          }
          this.infoForGooglePostalCodeRegion = new google.maps.InfoWindow({
            content: this.hintWindowContent(
              "<div style='font-weight:bold; color:black;'>" +
              this.translateService.instant(
                "new-address-modal.marker-information-from-google-map"
              ) +
              "</div>" +
              "<div style='font-weight:bold; color:black;'>" +
              this.translateService.instant("new-address-modal.postal_code") +
              ": " +
              this.newAddress.address_components.user_point_postal_code +
              "</div>" +
              (this.newAddress.address_components.region
                ? "<div style='font-weight:bold; color:black;'>" +
                  this.translateService.instant("new-address-modal.region") +
                  ": " +
                  this.newAddress.address_components.region +
                  "</div>"
                : "")),
            headerDisabled: true,
            pixelOffset: this.hintWindowPixelOffset(),
          });
          this.infoForGooglePostalCodeRegion.open(this.map, this.marker);
        } else {
          this.mobileMarkerInfo.header = this.translateService.instant(
            "new-address-modal.marker-information-from-google-map"
          );
          this.mobileMarkerInfo.message1 =
            this.translateService.instant("new-address-modal.postal_code") +
            ": " +
            this.newAddress.address_components.user_point_postal_code +
            " ";
          this.mobileMarkerInfo.message2 = this.newAddress.address_components
            .region
            ? this.translateService.instant("new-address-modal.region") +
              ": " +
              this.newAddress.address_components.region
            : "";
        }
      }
    }
    if (!this.capacitorIsNativePlatform()) {
      //console.log("this marker", this.marker);
      var latlng = new google.maps.LatLng(location.lat, location.lng);
      this.marker.setVisible(true);
      this.marker.setPosition(latlng);
    } else {
      this.mobileMarkerVisible = true;
    }

    this.changeDetector.detectChanges();
  }

  trackDeliveryAreas(index, item) {
    return index;
  }

  async openDeliveryAreaInfoModal(area) {
    this.DeliveryAreaInfoModal = await this.modalController.create({
      component: DeliveryAreasInfoModalComponent,
      cssClass: "openDeliveryAreaInfoModal",
      backdropDismiss: false,
      componentProps: {
        currentDeliveryArea: area,
      },
    });
    await this.DeliveryAreaInfoModal.present();
    this.DeliveryAreaInfoModal.onDidDismiss().then(() => {
      this.DeliveryAreaInfoModal = null;
    });
  }

  async presentLoading() {
    let message = this.translateService.instant("loading-please-wait");
    this.ionLoading = await this.loadingController.create({
      duration: 20000,
      message: message,
      cssClass: "ionicLoadingCss",
      keyboardClose: true,
    });
    return await this.ionLoading.present();
  }

  async onSaveAddressFromGps(addressFromGps) {
    this.saveAddressLoading = true;

    console.log("new address", addressFromGps);
    if (
      !addressFromGps ||
      !addressFromGps.address_components ||
      !addressFromGps.address_components.street ||
      !addressFromGps.address_components.street_number ||
      !addressFromGps.address_components.postal_code
    ) {
      const toast = await this.toastController.create({
        header: this.translateService.instant("alert"),
        duration: 3000,
        position: "middle",
        color: "danger",
        message: this.translateService.instant(
          "new-address-modal.please-fill-all-the-address-fields"
        ),
        buttons: ["OK"],
      });

      await toast.present();
      this.saveAddressLoading = false;
    } else if (
      addressFromGps &&
      addressFromGps.address_components &&
      addressFromGps.address_components.street &&
      addressFromGps.address_components.street_number &&
      addressFromGps.address_components.postal_code &&
      !addressFromGps.userLat &&
      !addressFromGps.userLng
    ) {
      const toast = await this.toastController.create({
        header: this.translateService.instant("alert"),
        duration: 3000,
        position: "middle",
        color: "danger",
        message: this.translateService.instant(
          "new-address-modal.please-fill-all-the-address-fields-correctly"
        ),
        buttons: ["OK"],
      });
      await toast.present();
      this.saveAddressLoading = false;
    } else if (
      addressFromGps &&
      addressFromGps.address_components &&
      addressFromGps.address_components.street &&
      addressFromGps.address_components.street_number &&
      addressFromGps.address_components.postal_code &&
      addressFromGps.userLat &&
      addressFromGps.userLng
    ) {
      if (
        ((this.deliveryAreas && this.deliveryAreas.length > 0) ||
          this.currentStore.disableDeliveryAreas) &&
        addressFromGps
      ) {
        await this.presentLoading();

        if (this.currentUser && !this.currentUser.only_visitor) {
          let currentUser = _.cloneDeep(this.currentUser);
          if (!_.isArray(currentUser.addresses)) {
            currentUser.addresses = [];
          }
          addressFromGps.address_id = uuid();
          currentUser.addresses.push(addressFromGps);
          this.dataStorageService
            .updateCustomerData({ updatedData: currentUser }, this.mo_token)

            .subscribe({
              next: async (res: any) => {
                if (!res || !res.success) {
                  if (this.ionLoading) {
                    await this.ionLoading.dismiss();
                    this.ionLoading = null;
                  }
                  const alert = await this.alertController.create({
                    header: this.translateService.instant("alert"),
                    message:
                      res && res.comment_id
                        ? this.translateService.instant(res.comment_id)
                        : this.translateService.instant(
                            "errorMessages.general_error"
                          ),

                    buttons: ["OK"],
                  });
                  await alert.present();
                  this.saveAddressLoading = false;
                } else {
                  if (this.ionLoading) {
                    await this.ionLoading.dismiss();
                    this.ionLoading = null;
                  }
                  this.saveAddressLoading = false;
                  if (!this.disableSelectAddress) {
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setDineIn(
                        _.cloneDeep(false)
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOrderPickup(
                        _.cloneDeep(false)
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setSelectedDineInTable(
                        _.cloneDeep(null)
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                        null
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCarTakewayComments(
                        null
                      )
                    );
                    console.log("set order pickup false");

                    // this.analyticsService.dmAnalyticsMessage(
                    //   "delivery_method",
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   this.sele
                    // );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                        true
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                        true
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCheckSelectedAddress(
                        _.cloneDeep(addressFromGps)
                      )
                    );
                  }

                  this.store.dispatch(
                    new AuthActions.SetUser(_.cloneDeep(currentUser))
                  );
                  this.modalController.dismiss(res);
                }
              },
              error: async (err) => {
                if (this.ionLoading) {
                  await this.ionLoading.dismiss();
                  this.ionLoading = null;
                }
                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message: this.translateService.instant(
                    "errorMessages.problem_reaching_server"
                  ),

                  buttons: ["OK"],
                });
                await alert.present();
                this.saveAddressLoading = false;
                return err;
              },
            });
        } else {
          this.saveAddressLoading = false;

          if (this.ionLoading) {
            // console.log("dismiss lllllloading");
            this.ionLoading.dismiss();
            this.ionLoading = null;
          }
          addressFromGps.address_id = uuid();

          console.log("set order pickup false");
          // this.analyticsService.dmAnalyticsMessage(
          //   "delivery_method",
          //   null,
          //   null,
          //   null,
          //   null,
          //   null,
          //   null,
          //   null
          // );

          if (!this.disableSelectAddress) {
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                true
              )
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setDineIn(_.cloneDeep(false))
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOrderPickup(
                _.cloneDeep(false)
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakewayComments(null)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setSelectedDineInTable(
                _.cloneDeep(null)
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setCheckSelectedAddress(
                _.cloneDeep(addressFromGps)
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenNotValidAddressModal(true)
            );
          }

          this.modalController.dismiss();
        }
      } else if (
        !this.deliveryAreas ||
        (this.deliveryAreas && this.deliveryAreas.length === 0)
      ) {
        this.saveAddressLoading = false;
        if (this.ionLoading) {
          this.ionLoading.dismiss();
          this.ionLoading = null;
        }
        const alert = await this.alertController.create({
          header: this.translateService.instant("alert"),
          message: this.translateService.instant(
            "new-address-modal.no-delivery-areas-that-serves-your-location"
          ),

          buttons: ["OK"],
        });
        await alert.present();
      }
    }
  }

  async onSaveAddress() {
    this.saveAddressLoading = true;
    console.log("new address", this.newAddress);
    if (
      !this.newAddress ||
      !this.newAddress.address_components ||
      !this.newAddress.address_components.street ||
      !this.newAddress.address_components.street_number ||
      !this.newAddress.address_components.postal_code
    ) {
      const alert = await this.alertController.create({
        header: this.translateService.instant("alert"),

        message: this.translateService.instant(
          "new-address-modal.please-fill-all-the-address-fields"
        ),
        buttons: ["OK"],
      });

      await alert.present();
      this.saveAddressLoading = false;
    } else if (
      this.newAddress &&
      this.newAddress.address_components &&
      this.newAddress.address_components.street &&
      this.newAddress.address_components.street_number &&
      this.newAddress.address_components.postal_code &&
      !this.newAddress.userLat &&
      !this.newAddress.userLng
    ) {
      const alert = await this.alertController.create({
        header: this.translateService.instant("alert"),

        message: this.translateService.instant(
          "new-address-modal.please-fill-all-the-address-fields-correctly"
        ),
        buttons: ["OK"],
      });
      await alert.present();
      this.saveAddressLoading = false;
    } else if (
      this.newAddress &&
      this.newAddress.address_components &&
      this.newAddress.address_components.street &&
      this.newAddress.address_components.street_number &&
      this.newAddress.address_components.postal_code &&
      this.newAddress.userLat &&
      this.newAddress.userLng
    ) {
      if (
        ((this.deliveryAreas && this.deliveryAreas.length > 0) ||
          this.currentStore.disableDeliveryAreas) &&
        this.newAddress
      ) {
        if (this.currentUser && !this.currentUser.only_visitor) {
          let currentUser = _.cloneDeep(this.currentUser);
          if (!_.isArray(currentUser.addresses)) {
            currentUser.addresses = [];
          }
          this.newAddress.address_id = uuid();
          currentUser.addresses.push(this.newAddress);
          this.dataStorageService
            .updateCustomerData({ updatedData: currentUser }, this.mo_token)

            .subscribe({
              next: async (res: any) => {
                if (!res || !res.success) {
                  const alert = await this.alertController.create({
                    header: this.translateService.instant("alert"),
                    message:
                      res && res.comment_id
                        ? this.translateService.instant(res.comment_id)
                        : this.translateService.instant(
                            "errorMessages.general_error"
                          ),

                    buttons: ["OK"],
                  });
                  await alert.present();
                  this.saveAddressLoading = false;
                } else {
                  this.saveAddressLoading = false;
                  if (!this.disableSelectAddress) {
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setDineIn(
                        _.cloneDeep(false)
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOrderPickup(
                        _.cloneDeep(false)
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setSelectedDineInTable(
                        _.cloneDeep(null)
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(
                        null
                      )
                    );
                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCarTakewayComments(
                        null
                      )
                    );
                    console.log("set order pickup false");

                    // this.analyticsService.dmAnalyticsMessage(
                    //   "delivery_method",
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   null,
                    //   this.sele
                    // );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOpenNotValidAddressModal(
                        true
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                        true
                      )
                    );

                    this.store.dispatch(
                      new DeliveryMethodAddressActions.setCheckSelectedAddress(
                        _.cloneDeep(this.newAddress)
                      )
                    );
                    this.store.dispatch(
                      new AuthActions.SetUser(_.cloneDeep(currentUser))
                    );
                  }

                  this.modalController.dismiss(res);
                }
              },
              error: async (err) => {
                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message: this.translateService.instant(
                    "errorMessages.problem_reaching_server"
                  ),

                  buttons: ["OK"],
                });
                await alert.present();
                this.saveAddressLoading = false;
                return err;
              },
            });
        } else {
          this.saveAddressLoading = false;
          this.newAddress.address_id = uuid();

          if (!this.disableSelectAddress) {
            this.store.dispatch(
              new DeliveryMethodAddressActions.setDineIn(_.cloneDeep(false))
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setOrderPickup(
                _.cloneDeep(false)
              )
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setSelectedDineInTable(
                _.cloneDeep(null)
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setCarTakewayComments(null)
            );
            console.log("set order pickup false");
            // this.analyticsService.dmAnalyticsMessage(
            //   "delivery_method",
            //   null,
            //   null,
            //   null,
            //   null,
            //   null,
            //   null,
            //   null
            // );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(
                true
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setCheckSelectedAddress(
                _.cloneDeep(this.newAddress)
              )
            );

            this.store.dispatch(
              new DeliveryMethodAddressActions.setOpenNotValidAddressModal(true)
            );
          }

          this.modalController.dismiss();
        }
      } else if (
        !this.deliveryAreas ||
        (this.deliveryAreas && this.deliveryAreas.length === 0)
      ) {
        this.saveAddressLoading = false;
        const alert = await this.alertController.create({
          header: this.translateService.instant("alert"),
          message: this.translateService.instant(
            "new-address-modal.no-delivery-areas-that-serves-your-location"
          ),

          buttons: ["OK"],
        });
        await alert.present();
      }
    }
  }

  async onCheckAddress() {
    if (
      this.newAddress &&
      this.newAddress.address_components &&
      this.newAddress.address_components.street
    ) {
      this.checkAutoCompleteAddress(
        this.newAddress.address_components.street,
        this.newAddress.address_components.street_number,
        this.newAddress.address_components.postal_code,
        null,
        null,
        this.newAddress.address_components.googleLat,
        this.newAddress.address_components.googleLng,
        false,
        false
      );
    } else {
      const alert = await this.alertController.create({
        header: this.translateService.instant("alert"),

        message: this.translateService.instant(
          "new-address-modal.please-fill-street"
        ),
        buttons: ["OK"],
      });

      await alert.present();
    }
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            // console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  // checkIfMapsLoaded() {
  //   this.checkIfMapsLoadedInterval = setInterval(() => {
  //     console.log("intervall check");
  //     if (typeof google === "object" && typeof google.maps === "object") {
  //       console.log("intervall dismissed map loaded");
  //       this.libraryLoaded = true;
  //       this.initializationSetAddress();
  //       clearInterval(this.checkIfMapsLoadedInterval);
  //     }
  //   }, 500);
  // }

  ngOnDestroy() {
    if (this.gpsEditAddressAlert) {
      this.gpsEditAddressAlert.dismiss();
      this.gpsEditAddressAlert = null;
    }

    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    if (this.DeliveryAreaInfoModal) {
      this.DeliveryAreaInfoModal.dismiss();
      this.DeliveryAreaInfoModal = null;
    }
    if (this.subs && this.subs.length > 0) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }

    if (this.enterKey) {
      document.removeEventListener("keyup", this.enterKey);
    }
    if (this.mobilePlatform) {
      google.maps.event.clearListeners(this.map, "dragstart");
      google.maps.event.clearListeners(this.map, "dragend");
    }

    if (this.marker) {
      google.maps.event.clearListeners(this.marker, "dragend");
      google.maps.event.clearListeners(this.marker, "dragstart");
      this.marker = null;
    }
    this.clearStoreMarkers();
    if (this.storeMarkerToast) {
      this.storeMarkerToast.dismiss();
      this.storeMarkerToast = null;
    }
    if (this.autocomplete) {
      google.maps.event.clearListeners(this.autocomplete, "place_changed");
      this.autocomplete = null;
    }

    if (this.ionLoading) {
      this.ionLoading.dismiss();
      this.ionLoading = null;
    }
  }
}
